"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGlobalClassifierIdentifiers = createGlobalClassifierIdentifiers;
// https://github.com/calm/evexia-vault-config/blob/master/files/staging/global_classifiers.yml
function createGlobalClassifierIdentifiers(circle) {
    var _a;
    const splitBy_ = (_a = circle === null || circle === void 0 ? void 0 : circle.globalClassifier) === null || _a === void 0 ? void 0 : _a.name.split('_');
    const countryCodeClassifier = splitBy_ === null || splitBy_ === void 0 ? void 0 : splitBy_.shift();
    const otherClassifiers = (splitBy_ === null || splitBy_ === void 0 ? void 0 : splitBy_.join('_')) || undefined;
    return { countryCodeClassifier, otherClassifiers };
}
//# sourceMappingURL=createGlobalClassifierIdentifiers.js.map